<template>
  <el-dialog
      :visible.sync="visible"
      title="批量设置工艺"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRules"
        label-width="80px"
    >
      <el-form-item prop="technologyId" label="工艺：">
        <technology v-model="dataForm.technologyId"></technology>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import Technology from '@/components/technology/index.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'technology-dialog',
  components: { Technology },
  data () {
    return {
      visible: false,
      dataForm: {
        technologyId: ''
      },
      makeIds: [],
      dataRules: {
        
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
      })
    },
    reset () {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    cancel () {
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm,
          makeIds:this.makeIds
        }
        this.$http.post('/trade/factorymake/technolog', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$emit('refreshDataList')
          this.$c.success(this.$t('prompt.success')).then(() => {
            this.cancel()
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
  },
}

</script>

<style lang='scss' scoped>

</style>
